import { useRef } from 'react'
import { OrbitControls, Environment } from '@react-three/drei'
import Car from './Car.jsx'
import Light from './Light.jsx'
import { Bloom, EffectComposer, Vignette,Autofocus, ToneMapping } from '@react-three/postprocessing'
import { ToneMappingMode } from 'postprocessing'
import AutoFocusDOF from './AutoFocusDOF.jsx'
import CameraAnimator from './CameraAnimator.jsx'

export default function Experience()
{
    const orbitRef = useRef()

    return <>

    <OrbitControls
    ref={orbitRef}
    minPolarAngle={Math.PI / 4}
    maxPolarAngle={Math.PI - Math.PI /2 }
    minDistance={1}
    maxDistance={10}
    enableDamping={true}
    rotateSpeed={0.25}
    zoomSpeed={0.9}
    />
    <CameraAnimator orbitControlsRef={orbitRef} />
   
    <EffectComposer>
    {/* {AutoFocus && (
        <AutoFocusDOF
        bokehScale={3} //blur scale
        resolution={1024} //resolution (decrease for performance)
        focusRadius={1}  // Distance from camera where objects are in focus
    focalLength={0.001}
      />
    )} */}
    <Bloom mipmapBlur intensity={1.0}/>
    <ToneMapping mode={ToneMappingMode.ACES_FILMIC}/>
    
    </EffectComposer>
    
    
    
    <fog attach="fog" args={['black', 0, 18.5]} />
        <Environment 
        background={false} 
        files={'./textures/env7.hdr'} env 
        
        environmentIntensity={0.7}
        exp
        />
        <Light
        
        />
        
        <Car/>
    </>
}